import { decode } from 'js-base64';
import { NotificationCard, useNotificationCard } from '../components/Card';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { NotificationTime } from '../components/Time';
import { Link } from 'react-router-dom';
import { Eye } from '@/assets/icons/bold';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import { NotificationLink } from '../components/NotificationLink';

const ProjectReviewWrapper = ({
  notification = () => {},
  onClose = () => {},
}) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const { candidate_count, project_name, sender_name, project_url } = data;
  const { markAsRead } = useNotificationCard();
  const { track } = useMixpanel();
  const parts = project_url?.split('/');
  const projectId = parts?.[parts?.length - 1];

  const reviewProfiles = () => {
    markAsRead();
    track({
      module: 'in-app-notification',
      data: {
        'user-event': 'click',
        'user-action': 'review-profiles',
      },
    });
    onClose();
  };

  return (
    <Flex>
      <Box>
        <Box height="40px" pos="relative">
          <Icon
            as={Eye}
            width="48px"
            height="48px"
            borderRadius="28px"
            color="#7D54D8"
            backgroundColor="#DCCCFF"
            border="8px solid #F9F6FF"
          />
        </Box>
      </Box>
      <Box ml="12px">
        <Flex pr="12px">
          <Text>
            <Text as="span" fontWeight="semiBold" pr="4px">
              {sender_name}
            </Text>
            has requested you to review
            <Text as="span" px="4px" fontWeight="semiBold">
              {candidate_count}
            </Text>
            {`${
              candidate_count > 1 ? 'candidates' : 'candidate'
            } in the project`}
            <NotificationLink
              to={`/projects/${projectId}`}
              label={project_name}
              onClose={onClose}
              notification={notification}
              data-test-id="project-link"
            />
          </Text>
        </Flex>
        <NotificationTime notification={notification} />
        <Box mt="12px">
          <Link to={`/projects/reviews`}>
            <Button
              onClick={reviewProfiles}
              data-test-id="review-profiles-button"
            >
              Review profiles
            </Button>
          </Link>
        </Box>
      </Box>
    </Flex>
  );
};

export const ProjectReview = ({ notification = {}, onClose = () => {} }) => {
  return (
    <NotificationCard notification={notification}>
      <ProjectReviewWrapper notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
